var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints, platformIconPathById } from '../../app.constants';
import { Kpi } from '../../../models/common';
import { BackendHttpService } from '../../core/backend-http.service';
import { TopExposure } from '../../../models/influencer';
import { InfluencerService } from '../influencer/influencer.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
var InfluencerPostService = /** @class */ (function (_super) {
    __extends(InfluencerPostService, _super);
    function InfluencerPostService(router, translate, influencerService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.influencerService = influencerService;
        return _this;
    }
    InfluencerPostService.prototype.getPostContent = function (urlHash, influencerId) {
        var _this = this;
        var apiUrl = "" + apiEndpoints.getPostDetails.replace(':urlHash', urlHash);
        return this.get(apiUrl, { influencerId: influencerId })
            .map(function (res) {
            if (res && res.data) {
                var normalizedPost = Object.assign({}, res.data, {
                    url: res.data.fullUrl,
                    video: res.data.videoUrl,
                    image: res.data.imageUrl,
                    isStory: res.data.story,
                    completed: res.data.completed,
                    isVideo: _this.influencerService.isVideoPost(res.data),
                    channelUrl: "https://" + res.data.relativePath
                });
                return normalizedPost;
            }
            else {
                return null;
            }
        });
    };
    InfluencerPostService.prototype.getPostMentions = function (fullUrl, relativePath) {
        var apiUrl = "" + apiEndpoints.getCurrentPostMentions;
        var apiParams = {
            blog_post_url: fullUrl,
            relativepath: relativePath,
        };
        return this.post(apiUrl, apiParams)
            .map(function (res) {
            return res.data;
        });
    };
    InfluencerPostService.prototype.getPostActivityLineChartData = function (urlHash, relativePath, postPublishedDate) {
        var apiUrl = "" + apiEndpoints.getPostOverviewLineChart;
        var apiParams = {
            url_hash: urlHash,
            relativepath: relativePath
        };
        return this.get(apiUrl, apiParams).map(function (res) { return res.postOverviewLineChart; });
    };
    InfluencerPostService.prototype.getPostDailyKpis = function (urlHash, influencerId, period, startDate, endDate) {
        var apiUrl = "" + apiEndpoints.getPostDailyKpis.replace(':urlHash', urlHash);
        return this.get(apiUrl, { influencerId: influencerId, period: period, periodFrom: startDate, periodTo: endDate ? endDate : '' })
            .map(function (res) { return res.data; });
    };
    InfluencerPostService.prototype.getPostKpi = function (fullUrl, relativePath) {
        var apiUrl = "" + apiEndpoints.getBlogPostKpi;
        var apiParams = {
            blog_post_url: fullUrl,
            relativepath: relativePath,
        };
        return this.post(apiUrl, apiParams)
            .map(function (res) {
            var postKpi = new Kpi();
            postKpi.engagement.value = res.data.engagement;
            postKpi.impact.value = res.data.impact;
            postKpi.impressions.value = res.data.impressions;
            postKpi.reach.value = res.data.reach;
            return postKpi;
        });
    };
    InfluencerPostService.prototype.getPostActivityGaugeChartData = function (urlHash, relativePath) {
        var apiUrl = "" + apiEndpoints.getBlogpostOverviewPieChart;
        var apiParams = {
            url_hash: urlHash,
            relativepath: relativePath,
        };
        return this.get(apiUrl, apiParams).map(function (res) {
            return res.blogpostOverviewPieChart ? res.blogpostOverviewPieChart.chartData : null;
        });
    };
    InfluencerPostService.prototype.getTopPosts = function (influencerId, numberOfPosts, performingScore) {
        var apiUrl = "" + apiEndpoints.getTopPosts.replace(':influencerId', influencerId);
        var apiParams = {
            period: 30,
            limit: numberOfPosts ? numberOfPosts : 6,
            performingScore: performingScore
        };
        return this.get(apiUrl, apiParams).map(function (res) {
            return res.data;
        });
    };
    InfluencerPostService.prototype.getRelatedPosts = function (influencerId) {
        var apiUrl = "" + apiEndpoints.getRelatedPosts.replace(':influencerId', influencerId);
        var apiParams = {
            period: 30,
        };
        return this.get(apiUrl, apiParams).map(function (res) {
            if (!res || !res.data) {
                return null;
            }
            var relatedPosts = new Array();
            if (res.data.reach) {
                var reachPost = new TopExposure();
                reachPost.date = res.data.reach.publishedDate;
                reachPost.picture = res.data.reach.imageUrl;
                reachPost.title = res.data.reach.title;
                reachPost.value = res.data.reach.reach;
                reachPost.platform = res.data.reach.platform;
                reachPost.influencer_id = res.data.reach.influencerId;
                reachPost.urlHash = res.data.reach.urlHash;
                reachPost.relativepath = res.data.reach.relativePath;
                relatedPosts.push(reachPost);
            }
            if (res.data.engagement) {
                var engagementPost = new TopExposure();
                engagementPost.date = res.data.engagement.publishedDate;
                engagementPost.picture = res.data.engagement.imageUrl;
                engagementPost.title = res.data.engagement.title;
                engagementPost.value = res.data.engagement.engagement;
                engagementPost.platform = res.data.engagement.platform;
                engagementPost.influencer_id = res.data.engagement.influencerId;
                engagementPost.urlHash = res.data.engagement.urlHash;
                engagementPost.relativepath = res.data.engagement.relativePath;
                relatedPosts.push(engagementPost);
            }
            if (res.data.impact) {
                var impactPost = new TopExposure();
                impactPost.date = res.data.impact.publishedDate;
                impactPost.picture = res.data.impact.imageUrl;
                impactPost.title = res.data.impact.title;
                impactPost.value = res.data.impact.impact * 100;
                impactPost.platform = res.data.impact.platform;
                impactPost.influencer_id = res.data.impact.influencerId;
                impactPost.urlHash = res.data.impact.urlHash;
                impactPost.relativepath = res.data.impact.relativePath;
                relatedPosts.push(impactPost);
            }
            return relatedPosts;
        });
    };
    InfluencerPostService.prototype.addNewMention = function (keyword, keywordType, languages, topicId, industryId) {
        var apiUrl = "" + apiEndpoints.addNewMention;
        var apiParams = {
            keyword: keyword,
            keywordType: keywordType,
            languages: languages,
            topic_id: topicId,
            vertical_id: industryId,
        };
        return this.post(apiUrl, JSON.stringify(apiParams)).map(function (res) {
            return res.data;
        });
    };
    InfluencerPostService.prototype.checkPostMentionExist = function (mention) {
        var apiUrl = "" + apiEndpoints.checkPostMentionExist;
        var apiParams = {
            mention: mention,
        };
        return this.get(apiUrl, apiParams).map(function (res) {
            return res.data;
        });
    };
    InfluencerPostService.prototype.approveMention = function (keywordId, languages, topicId, industryId) {
        if (languages === void 0) { languages = [0]; }
        var apiUrl = apiEndpoints.setApprovedMention + "/" + keywordId;
        var apiParams = {
            topic_id: topicId,
            vertical_id: industryId,
            languages: languages,
        };
        return this.post(apiUrl, JSON.stringify(apiParams)).map(function (res) {
            return res.data;
        });
    };
    InfluencerPostService.prototype.addNewPostMention = function (keywordId, blogPostUrl, blogPostPublishDate, postRelativePath, blogPostUrlHash, influencerId) {
        var apiUrl = "" + apiEndpoints.addNewBlogPostMentions;
        var apiParams = {
            blog_post_url: blogPostUrl,
            keywords: keywordId,
            published_date: blogPostPublishDate,
            relativepath: postRelativePath,
            url_hash: blogPostUrlHash,
            influencerId: influencerId
        };
        return this.post(apiUrl, JSON.stringify(apiParams)).map(function (res) {
            return res.data;
        });
    };
    InfluencerPostService.prototype.getPlatformIconById = function (id) {
        return platformIconPathById[id] !== undefined ? platformIconPathById[id].path : '';
    };
    return InfluencerPostService;
}(BackendHttpService));
export { InfluencerPostService };



// WEBPACK FOOTER //
// ./src/app/services/influencer-post/influencer-post.service.ts.pre-build-optimizer.js